import { useEffect } from "react";

interface PageMeta {
  title: string;
  description?: string;
  keywords?: string;
}

const setMeta = (name: string, content: string) => {
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
};

/**
 * Update the document title and description/keywords meta tags per page.
 */
export function usePageMeta({ title, description, keywords }: PageMeta) {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
    if (description) {
      setMeta("description", description);
    }
    if (keywords) {
      setMeta("keywords", keywords);
    }
  }, [title, description, keywords]);
}

export default usePageMeta;